import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import TREATMENTS from './components/treatments/Treatments'
import Services from './components/services/Services'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import Experience from './components/experience/Experience'
// import Photo from './components/photo/Photo'

const App = () => {
  return (
    <>
        {/* <Photo /> */}
        <Header />
        <Nav />
        <Experience />
        <TREATMENTS />
        <About />
        <Services />
        <Contact />
        <Footer />

    </>
  )
}

export default App